import styled from 'styled-components'

import Form from '../../../shared/components/Form'
import Input from '../../../shared/components/Input'

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  width: 100%;
  margin-bottom: 20px;
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
export const StyledForm = styled(Form)`
  padding: 0;
`
export const StyledInput = styled(Input)`
  margin: 0;
`
